import { customSortApprovalAmount, customSortApprovedAmount, customSortDate, customSortPoNo, customSortPurchaseDate, customSortSpentAmount, customSortTotalAmount, genericSort, sortByAmount, sortByBaseAmount, sortByCgst, sortByIgst, sortBySellPrice, sortBySgst } from "../customSort/customSort";

export const columnsDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "Po No",
    accessor: "poNo",
    sortType:customSortPoNo
  },
  {
    Header: "Purchase Order Date",
    accessor: "purchasedate",
    sortType:customSortPurchaseDate
  },
  {
    Header: "Major Type",
    accessor: "majorType",
    sortType:genericSort
  },
  {
    Header: "Minor Type",
    accessor: "minorType",
    sortType:genericSort
  },
  {
    Header: "Merchant Name",
    accessor: "merchantName",
    sortType:genericSort
  },
  {
    Header: "Approved Amount",
    accessor: "approvedAmount",
    sortType:customSortApprovedAmount

  },
  {
    Header: "Spent Amount",
    accessor: "spentAmount",
    sortType:customSortSpentAmount

  },
  {
    Header: "Invoice",
    accessor: "invoice",    
  },
  {
    Header: "Action",
    accessor: "action",
  },
];

export const pendingDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "Po No",
    accessor: "poNo",
    sortType:customSortPoNo
  },
  {
    Header: "Purchase Order Date",
    accessor: "purchasedate",
    sortType:customSortPurchaseDate
  },
  {
    Header: "Major Type",
    accessor: "majorType",
    sortType:genericSort

  },
  {
    Header: "Minor Type",
    accessor: "minorType",
    sortType:genericSort

  },
  {
    Header: "Merchant Name",
    accessor: "merchantName",
    sortType:genericSort

  },
  {
    Header: "Requested Amount",
    accessor: "approvalAmount",
    sortType:customSortApprovalAmount
  },

  {
    Header: "Invoice",
    accessor: "invoice",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];
export const rejectedDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "Po No",
    accessor: "poNo",
    sortType:customSortPoNo
  },
  {
    Header: "Purchase Order Date",
    accessor: "purchasedate",
    sortType:customSortPurchaseDate
  },
  {
    Header: "Major Type",
    accessor: "majorType",
    sortType:genericSort
  },
  {
    Header: "Minor Type",
    accessor: "minorType",
    sortType:genericSort
  },
  {
    Header: "Requested Amount",
    accessor: "approvalAmount",
    sortType:customSortApprovalAmount

  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];

export const prItemDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  
  {
    Header: "Name",
    accessor: "name",
    sortType:genericSort
  },
  {
    Header: "Type",
    accessor: "type",
  },
  {
    Header: "Item Code",
    accessor: "itemcode",
  },
  {
    Header: "Inter State Tax Rate",
    accessor: "taxRate",
  },  
  {
    Header: "Cost Price",
    accessor: "sellingPrice",
    sortType:sortBySellPrice
  },
 
  
  {
    Header: "Action",
    accessor: "action",
  },
  
];

export const gstDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "PO No",
    accessor: "poNo",
    sortType:customSortPoNo
  },
  {
    Header: "Vendor Name",
    accessor: "vendorName",
    sortType:genericSort

  },
  {
    Header: "GST Number",
    accessor: "gstNumber",
  },
  {
    Header: "Base Amount",
    accessor: "baseAmount",
    sortType:sortByBaseAmount
  },
  {
    Header: "IGST Amount",
    accessor: "igstAmt",
    sortType:sortByIgst

  },
  {
    Header: "SGST Amount",
    accessor: "sgstAmt",
    sortType:sortBySgst
  },
  {
    Header: "CGST Amount",
    accessor: "cgstAmt",
    sortType:sortByCgst

  },
  {
    Header: "Total GST",
    accessor: "totalGst",
    sortType:customSortTotalAmount
  },
  
  
];

export const salesItemDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  
  {
    Header: "Name",
    accessor: "name",
    sortType:genericSort
  },
  {
    Header: "Type",
    accessor: "type",
  },
  {
    Header: "Item Code",
    accessor: "itemcode",
  },
  {
    Header: "Inter State Tax Rate",
    accessor: "taxRate",
  }, 
  {
    Header: "Client Name",
    accessor: "clientName",
    sortType:genericSort
  },  
  {
    Header: "Currency",
    accessor: "currency",
  },
  {
    Header: "Selling Price",
    accessor: "sellingPrice",
    sortType:sortBySellPrice
  },
  {
    Header: "Action",
    accessor: "action",
  },
  
];